// Commons scroll memory — a tiny, explicit, session-lifetime cache of
// scroll positions for browsable surfaces (Home + Category pages).
//
// Deliberately module-scoped and *not* backed by sessionStorage. We
// want "remember where I was for the duration of this browsing
// session" — not across a page reload. A refresh should start clean;
// closing and reopening the tab should start clean.
//
// This module is a scroll-restoration helper *only*. It does not
// participate in routing or destination selection. Callers set the
// `restoreScroll: true` navigation state as a hint that a Back arrow
// is returning the visitor to a previously-visited browsing surface;
// ScrollMemory.jsx watches for that hint and reads from this cache.
// Structural destinations continue to be resolved separately.

const _memory = new Map();

export function remember(key, y) {
  if (!key) return;
  _memory.set(key, y);
}

export function recall(key) {
  if (!key) return undefined;
  return _memory.get(key);
}

export function forget(key) {
  if (!key) return;
  _memory.delete(key);
}

// Only two kinds of surface are restoration targets today: Home and
// the six Category library pages. Detail, Manage, Roots, Story,
// Profile and Create are not "browsable lists you scroll and return
// to" — they're focused screens whose scroll state we don't preserve.
export function scrollKeyForPath(pathname) {
  if (pathname === "/") return "home";
  if (pathname.startsWith("/commons/")) {
    return `commons/${pathname.slice("/commons/".length).split("/")[0]}`;
  }
  return null;
}
